module.exports = __webpack_public_path__ + "static/media/bg-user-chat-dots.d23ac342.svg";